
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FEE6D8]/10">
      <div className="text-center bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-5xl font-bold mb-4 text-[#003a70]">404</h1>
        <p className="text-xl text-gray-700 mb-6">Oops! Page not found</p>
        <a href="/" className="text-[#003a70] hover:text-[#003a70]/80 bg-[#FEE6D8] hover:bg-[#FEE6D8]/90 px-6 py-3 rounded-full font-medium transition-all duration-300">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
